import type { SiteThemeId } from './siteTheme';

// Одна очередь на аккаунт: старый ответ не побеждает более поздний выбор.
export function createSiteThemeWriter(
  write: (theme: SiteThemeId) => Promise<unknown>,
  onStatus: (status: 'saving' | 'saved' | 'error') => void,
) {
  let pending: SiteThemeId | null = null;
  let busy = false;
  let disposed = false;
  const drain = async () => {
    if (busy || disposed) return;
    busy = true;
    while (pending && !disposed) {
      const value = pending;
      pending = null;
      try {
        await write(value);
        if (!disposed && !pending) onStatus('saved');
      } catch {
        if (!disposed && !pending) onStatus('error');
      }
    }
    busy = false;
  };
  return {
    select(value: SiteThemeId) {
      if (disposed) return;
      pending = value;
      onStatus('saving');
      void drain();
    },
    dispose() { disposed = true; pending = null; },
  };
}
